/**
 * What a key does to a chart's cursor. Pure, so the keyboard contract every
 * categorical chart shares is testable without a DOM.
 */

type CursorKeyAction =
  | { kind: 'step'; delta: 1 | -1 }
  | { kind: 'jump'; to: 'first' | 'last' }
  | { kind: 'dismiss' }
  | { kind: 'activate' }
  | { kind: 'none' };

export function cursorActionFor(key: string): CursorKeyAction {
  switch (key) {
    case 'ArrowRight':
    case 'ArrowUp':
      return { kind: 'step', delta: 1 };
    case 'ArrowLeft':
    case 'ArrowDown':
      return { kind: 'step', delta: -1 };
    case 'Home':
      return { kind: 'jump', to: 'first' };
    case 'End':
      return { kind: 'jump', to: 'last' };
    case 'Escape':
      return { kind: 'dismiss' };
    case 'Enter':
    case ' ':
      return { kind: 'activate' };
    default:
      return { kind: 'none' };
  }
}

/**
 * The index after one step from `current` (-1 when nothing is active).
 *
 * From nothing, forward lands on the first reading and back on the last.
 * Clamped, not wrapped. Wrapping in a time series silently teleports the
 * reader from December to January.
 */
export function steppedIndex(current: number, delta: 1 | -1, count: number): number {
  const from = current < 0 ? (delta > 0 ? -1 : count) : current;
  return Math.min(count - 1, Math.max(0, from + delta));
}
